module.exports = __webpack_public_path__ + "img/experian.7faf331d.svg";